import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { uploadFnfLetters } from "../../api/resignationChecklist";
import { useDispatch, useSelector } from "react-redux";
import { showAlert, showSuccess } from "../../actions/alert";
import { handleAxiosError } from "../../config/action-config";
import {
  FnfProcessChecklistById,
  FnfProcessChecklistSubmit,
} from "../../api/resignationCheckliistAssign";
import { Link } from "react-router-dom";

export default function FNFPopup({ open, setOpen, refreshTable }) {
  const [loader, setLoader] = useState(false);
  const ref = useRef();
  const [isSelected, setIsSelected] = useState(false);
  const [isdoc, setIsDoc] = useState(false);
  const [isrel, setIsRel] = useState(false);
  const [isfnf, setIsFnf] = useState(false);
  const [fnfFile, setFnfFile] = useState({ fnf: "" });
  const [expFile, setExpFile] = useState({ exp: "" });
  const [relFile, setRelFile] = useState({ rel: "" });
  const [empData, setEmpData] = useState({
    last_day_completion: "",
    emp_confirmation_email: "",
  });
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const date = new Date();
  const relRef = useRef(null);
  const expRef = useRef(null);
  const fnfRef = useRef(null);
  const [prefilledData, setPrefilledData] = useState({});

  const handleInputChange = (event) => {
    setEmpData({
      ...empData,
      [event.target.name]: event.target.value,
    });
  };
  useEffect(() => {
    if (open?.data?.emp_id) {
      getFnfDataById();
    }
  }, [open?.data?.emp_id]);
  async function getFnfDataById() {
    try {
      const { data } = await FnfProcessChecklistById(
        open?.data?.emp_id,
        user.token
      );
      if (data.data.length) {
        setPrefilledData(data.data[0]);
        setEmpData({
          last_day_completion: data.data[0].last_day_completion,
          emp_confirmation_email: data.data[0].emp_email_confirmation,
        });
      }
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  const handleimageUpload = async (event, type) => {
    setLoader(false);
    const file = event.target.files?.[0];
    const formData = new FormData();
    formData.append("letter_type", type);
    formData.append("files", file);
    if (type === "fnf") {
      setFnfFile({ fnf: file.name });
    } else if (type === "exp") {
      setExpFile({ exp: file.name });
    } else if (type === "rel") {
      setRelFile({ rel: file.name });
    }
    try {
      const { data } = await uploadFnfLetters(
        open?.data?.emp_id,
        formData,
        user.token
      );

      if (type === "fnf") {
        setIsFnf(true);
      } else if (type === "exp") {
        setIsRel(true);
      } else if (type === "rel") {
        setIsDoc(true);
      }

      dispatch(showAlert(data.msg));
      refreshTable();
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleAxiosError(error, dispatch);
    }
  };
  const onSubmit = async (event) => {
    event.preventDefault();

    try {
      const { data } = await FnfProcessChecklistSubmit(
        empData,
        open?.data?.emp_id,
        user.token
      );
      setPrefilledData({});
      setEmpData({
        last_day_completion: "",
        emp_confirmation_email: "",
      });
      setOpen(false);
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  console.log(open?.data?.emp_id);
  console.log(empData, "idd");
  return (
    <Dialog
      open={open.status}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DialogTitle sx={{ textAlign: "center" }}>Exit Process</DialogTitle>
      <Box component="form">
        <DialogContent>
          {/* {showLoader ? (
          <>
            <br />
            <CircularProgress />
          </>
        ) : (
          <></>
        )}
        <br /> */}
          <form>
            <Grid container spacing={2} className="newTicketTextfield">
              <Grid item xs={12} md={6} sm={6}>
                <TextField
                  name="Name"
                  fullWidth
                  label="Name"
                  type="text"
                  value={open?.data?.emp_name}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <TextField
                  name="last_working_day"
                  fullWidth
                  label="Last Working Day"
                  value={formatDateToYYYYMMDD(open?.data?.last_working_day)}
                  disabled
                  type="date"
                />
              </Grid>
              <Grid item xs={12} md={6} sm={6}>
                <TextField
                  value={empData.emp_confirmation_email}
                  fullWidth
                  name="emp_confirmation_email"
                  onChange={handleInputChange}
                  label="Employee Email (On which letters have mailed)"
                  type="text"
                  // value={open?.data?.employee_email}
                  required
                />
              </Grid>

              {/* <Grid item xs={12} md={6} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="served-last-working-day-label">
                    Is Last Working Day Completed
                  </InputLabel>
                  <Select
                    value={empData.last_day_completion}
                    label="served last working day"
                    name="last_day_completion"
                    onChange={handleInputChange}
                  >
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  md={12}
                  sm={12}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    ref={relRef}
                    accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    style={{ display: "none" }}
                    type="file"
                    onChange={(e) => handleimageUpload(e, "rel")}
                  />
                  {loader === true ? (
                    <Loading />
                  ) : (
                    <>
                      <label htmlFor={`rel-button-file`}>
                        <Button
                          variant="outlined"
                          component="span"
                          startIcon={
                            isdoc === true ? (
                              <CheckCircleIcon color="success" />
                            ) : (
                              <CloudUploadIcon />
                            )
                          }
                          className="add-button btn-align-right"
                          onClick={() => relRef.current.click()}
                        >
                          Upload Relieving Letter
                        </Button>
                      </label>

                      {prefilledData.releiving_letter ? (
                        <Link
                          to={`https://cloudapps.vastedge.com/${prefilledData.releiving_letter}`}
                        >
                          Relieving Letter
                        </Link>
                      ) : (
                        <Typography variant="body1" style={{ marginLeft: 10 }}>
                          {relFile.rel}
                        </Typography>
                      )}
                    </>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  sm={12}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  {" "}
                  <input
                    ref={expRef}
                    accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    style={{ display: "none" }}
                    type="file"
                    onChange={(e) => handleimageUpload(e, "exp")}
                  />
                  {loader === true ? (
                    <Loading />
                  ) : (
                    <>
                      <label htmlFor={`exp-button-file`}>
                        <Button
                          variant="outlined"
                          component="span"
                          startIcon={
                            isrel === true ? (
                              <CheckCircleIcon color="success" />
                            ) : (
                              <CloudUploadIcon />
                            )
                          }
                          className="add-button btn-align-right"
                          onClick={() => expRef.current.click()}
                        >
                          Upload Experience Letter
                        </Button>
                      </label>
                      {prefilledData.experience_letter ? (
                        <Link
                          to={`https://cloudapps.vastedge.com/${prefilledData.experience_letter}`}
                        >
                          Experience Letter
                        </Link>
                      ) : (
                        <Typography variant="body1" style={{ marginLeft: 10 }}>
                          {expFile.exp}
                        </Typography>
                      )}
                    </>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  sm={12}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    ref={fnfRef}
                    accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    style={{ display: "none" }}
                    type="file"
                    onChange={(e) => handleimageUpload(e, "fnf")}
                  />
                  {loader === true ? (
                    <Loading />
                  ) : (
                    <>
                      <label htmlFor={`fnf-button-file`}>
                        <Button
                          variant="outlined"
                          component="span"
                          startIcon={
                            isfnf === true ? (
                              <CheckCircleIcon color="success" />
                            ) : (
                              <CloudUploadIcon />
                            )
                          }
                          onClick={() => fnfRef.current.click()}
                          className="add-button btn-align-right"
                        >
                          Upload FNF Letter
                        </Button>
                      </label>
                      {prefilledData.fnf_letter ? (
                        <Link
                          to={`https://cloudapps.vastedge.com/${prefilledData.fnf_letter}`}
                        >
                          FNF Letter
                        </Link>
                      ) : (
                        <Typography variant="body1" style={{ marginLeft: 10 }}>
                          {fnfFile.fnf}
                        </Typography>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen({ status: false, id: "" });
              setPrefilledData({});
              setEmpData({
                last_day_completion: "",
                emp_confirmation_email: "",
              });
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            // disabled={/^Trial_User$/i.test(user.role) ? true : false}
            // onClick={handleSubmit(onNewTicketSubmit)}
            type="submit"
            className="blue-button"
            onClick={onSubmit}
          >
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
function Loading() {
  return (
    <Box sx={{ display: "flex" }}>
      <CircularProgress />
    </Box>
  );
}
function formatDateToYYYYMMDD(isoDateString) {
  if (!isoDateString) return ""; // Return empty string if input is falsy

  const datePortion = isoDateString.split("T")[0];
  return datePortion;
}
